import { clubFeaturesRequiredMessage } from './club-features-gate'
import { UserFacingError } from './errors'

export class ClubFeaturesRequiredError extends UserFacingError {
  readonly roles: readonly string[]

  constructor(roles: readonly string[] = []) {
    super(clubFeaturesRequiredMessage(roles))
    this.name = 'ClubFeaturesRequiredError'
    this.roles = roles
  }
}

export const SEAT_ERROR_CODES = {
  lastAdmin: 'LAST_ADMIN',
  cannotModifySelf: 'CANNOT_MODIFY_SELF',
  cannotDeleteActiveMember: 'CANNOT_DELETE_ACTIVE_MEMBER',
  duplicateEmail: 'DUPLICATE_EMAIL',
  invitationNotFound: 'INVITATION_NOT_FOUND',
  alreadyOnRoster: 'ALREADY_ON_ROSTER',
  crewSeatUnavailable: 'CREW_SEAT_UNAVAILABLE',
  placeholderNotInvitable: 'PLACEHOLDER_NOT_INVITABLE',
  placeholderNotFound: 'PLACEHOLDER_NOT_FOUND',
} as const

export class CannotModifySelfError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Cannot modify self')
    this.name = 'CannotModifySelfError'
  }
}

export class LastAdminError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Cannot demote last admin')
    this.name = 'LastAdminError'
  }
}

export class CannotDeleteActiveMemberError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Cannot delete an active member')
    this.name = 'CannotDeleteActiveMemberError'
  }
}

export class DuplicateEmailError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Email already in use')
    this.name = 'DuplicateEmailError'
  }
}

export class DuplicatePhoneError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Phone already in use')
    this.name = 'DuplicatePhoneError'
  }
}

export class InvitationNotFoundError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Invitation not found')
    this.name = 'InvitationNotFoundError'
  }
}

export class PermissionDeniedError extends UserFacingError {
  constructor() {
    super("You don't have permission to perform this action")
    this.name = 'PermissionDeniedError'
  }
}

export class CheckDuplicatesFailedError extends UserFacingError {
  constructor() {
    super("Couldn't verify duplicates")
    this.name = 'CheckDuplicatesFailedError'
  }
}

export class AlreadyOnRosterError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'This person is already on your roster.')
    this.name = 'AlreadyOnRosterError'
  }
}

export class CrewSeatUnavailableError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Your crew has no open seats. Add a seat first.')
    this.name = 'CrewSeatUnavailableError'
  }
}

export class PlaceholderNotInvitableError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? "This member can't be invited right now.")
    this.name = 'PlaceholderNotInvitableError'
  }
}

export class PlaceholderNotFoundError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Something went wrong. Please try again.')
    this.name = 'PlaceholderNotFoundError'
  }
}
